import { combineReducers } from "redux";
import { navigationReducer } from "./navigation/reducer";
import { animationReducer } from "./animation/reducer";
import { myFlowReducer } from "./myflow/reducer";
import user from "./user/reducer";
import application from "./application/reducer";
import { authReducer } from "./auth/reducer";
import { favouriteReducer } from "./favourites/reducer";

export interface StoreState {
  user: UserState;
  application: ApplicationState;
  auth: AuthState;
  favourites: FavouriteState;
}

export default combineReducers({
  application,
  auth: authReducer,
  favourites: favouriteReducer,
  user,
  navigationReducer,
  animationReducer,
  myFlowReducer,
});



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/index.ts